export default "__VITE_ASSET__f6280271__"